(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      const searchPopupMobOpen = this.querySelector("#PredectiveItemsWrapper");
      if(searchPopupMobOpen){
        searchPopupMobOpen.addEventListener('click',this.searchPopupOpen.bind(this));
      }

    const searchPopupMobClose = this.querySelectorAll("#SearchCloseMobPopoMB");
    for(let i=0; i<searchPopupMobClose.length; i++){
      if(searchPopupMobClose[i]){searchPopupMobClose[i].addEventListener('click',this.searchOverPopCloseMB.bind(this))}
    }

      const overlayPopupSeachClose = this.querySelector('.JPS_MobSearchMain.onlyShowMobileTab');
      if(overlayPopupSeachClose){
        overlayPopupSeachClose.addEventListener('click',this.searchOverPopClose.bind(this));
      }

      const searchDeskOpen = this.querySelector(".Dekstop_Predective_Serach");
      if(searchDeskOpen){
        searchDeskOpen.addEventListener('click',this.searchDeskOpen.bind(this));
      }

      this.createObserver();
    }

     searchDeskOpen(){
      document.body.classList.add("DesktopDynoSearch");
    }

    searchPopupOpen(){
      document.body.classList.add("MobilePredective_Search");
    }

    searchOverPopCloseMB(e){
      document.body.classList.remove("MobilePredective_Search");
    }

    searchOverPopClose(e){
      if(e.target.querySelector('.field') && e.target.querySelector('.predictive-search, .predictive-search-results')){
        document.body.classList.remove("MobilePredective_Search");
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if(this.searchModal){
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jps_video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const iframes = document.querySelectorAll("iframe[data-src]");
    if ("IntersectionObserver" in window) {
      let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            let iframe = entry.target;
            iframe.src = iframe.getAttribute("data-src");
            iframe.removeAttribute("data-src");
            observer.unobserve(iframe);
          }
        });
      });
      iframes.forEach((iframe) => {
        observer.observe(iframe);
      });
    } else {
      iframes.forEach((iframe) => {
        iframe.src = iframe.getAttribute("data-src");
        iframe.removeAttribute("data-src");
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
